
/*
 * Gestion de la eresa dans la fiche produit
 * @author Aurélien Renault
 */
var Eresa = {

    boxName: 'e-resaBox',
    box: $('#e-resaBox'),
    content: $('#content_e-resaBox'),
    stores: {}, // La liste de tous les magasin ereservation
    storeSelected: {}, // Le magasin sélectionné
    places: {}, // Google Place
    storeHtml: '', // Le template des magasins
    step: 0, // Le template des magasins
    product: {
        product_id : '',
        color_id : '',
        size_id : ''
    }, // les info du produit
    nbKilometerMax: 50, // Le nombre de kilometre maximum pour la recherche du magasin

    // Permet de charger tous les magasins en e-resa (etape 2). Ici pas de carte
    storeInit: function() {

        // Initialisation du template des stores
        if (this.storeHtml === '') {
            this.storeHtml = $('.store_locator .store', Eresa.box)[0].outerHTML;
        }
        Mustache.parse(this.storeHtml);

        var data = {
            'product_id' : Eresa.product.product_id,
            'color_id' : Eresa.product.color_id,
            'size_id' : Eresa.product.size_id,
            'version' : 2,
        };

        var self = this;
        $.ajax({
            type : 'post',
            url : path_relative_root + 'ajax_get_store_ereservation.php',
            data: data,
            success : function (boutique_bookinstore) {

                if (boutique_bookinstore) {
                    self.stores = $.parseJSON(boutique_bookinstore);

                    // Pour la restriction google
                    var countries = [];
                    var select = $('select[name="country"]', Eresa.box);
                    var store = '';
                    var length = self.stores.length;
                    // Construction de la liste des pays disponibles
                    for (var i = 0 ; i < length ; i++) {
                        store = self.stores[i];
                        var doublon = countries.find(function (val) {
                            return val === store.iso;
                        });
                        if (doublon === undefined) {
                            countries.push(store.iso);
                            // Pour la construction du select
                            var option = '<option value="' + store.id + '">' + store.country + '</option>';
                            select.append(option);
                        }
                    }

                    // Le trigger sur le select pour bien sélectionner le produit (car le select utilise un plugin)
                    select.trigger('change');

                    var options = {// jsmaps marker update?
                        types: ['geocode'],
                        mapId: google_map_id, // dans le cas du chargement de la carte
                    };

                    if (countries && countries.length <= 5) {
                        options.componentRestrictions = {
                            country: countries
                        };
                    }

                    var eltAutoAdresse = document.getElementById('eresa_autoAddress');
                    // Initialisation de l'autocomplete
                    self.places = new google.maps.places.Autocomplete(eltAutoAdresse, options);

                    google.maps.event.addListener(self.places, 'place_changed', self.storeOnPlaceChange.bind(self));
                    google.maps.event.addDomListener(eltAutoAdresse, 'keydown', function(evt) {
                        // On bloque la touche enter
                        if (evt.keyCode === 13) {
                            evt.preventDefault();
                        }
                    });

                    // On "active" la nouvelle étape
                    $('#step' + Eresa.step).addClass('actif');
                } else {
                    alertV2(Translator.translate('no_store_ereservation'))
                }
            }
        });
    },
    /**
     * Event quand on change d'adresse
     */
    storeOnPlaceChange: function() {

        var storeLocator = $('.store_locator', Eresa.box);
        var place = this.places.getPlace();

        // Récupération de la latitude/longitude de la place trouvé pour le calcul de la distance avec tous les magasins
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        var distance = 0;

        storeLocator.removeClass('loaded');

        var storesOrdonnee = []; // La liste de tous les magasin ereservation ordonné par distance
        // On va parcourir chaque magasin trouvé pour calculer la distance entre le magasin et la position de l'adresse
        $.each(this.stores, function(index, store) {
            // Si la latitude exist
            if (store.lat != 0) {
                // Calcul de la distance avec formule haversine
                // Le calcul est le même que dans la fonction du BO en BDD)
                var radlon1 = (longitude * Math.PI) / 180;
                var radlon2 = (store.lng * Math.PI) / 180;
                var radlat1 = (latitude * Math.PI) / 180;
                var radlat2 = (store.lat * Math.PI) / 180;
                var dlo = (radlon2 - radlon1) / 2;
                var dla = (radlat2 - radlat1) / 2;
                var a = Math.sin(dla) * Math.sin(dla) + Math.cos(radlat2) * Math.sin(dlo) * Math.sin(dlo);
                distance = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); // 6371 rayon de la terre
                store.distance = Math.round(distance * 100) / 100;
            }
            var length = storesOrdonnee.length;
            if (length > 0) {
                // Maintenant on va ordonner la liste des magasins au fur et à mesure
                for (var i = 0 ; i < length ; i++) {
                    // Si la valeur est plus petite que le premier element
                    if (store.distance < storesOrdonnee[i].distance) {
                        storesOrdonnee.splice(i, 0 , store);
                        break;
                    } else if (storesOrdonnee[i+1] !== undefined) { // si on a un élément suivant
                        // Si la distance du magasin est supérieur au courant et inférieur au suivant alors on a trouvé sa place
                        if (store.distance > storesOrdonnee[i].distance && store.distance < storesOrdonnee[i+1].distance) {
                            storesOrdonnee.splice(i+1, 0 , store);
                            break;
                        }
                    } else { // si plus d'élement suivant on met la valeur à la fin
                        storesOrdonnee.push(store);
                    }
                }
            } else {
                storesOrdonnee.push(store);
            }
        });

        // Maintenant qu'on a les magasin dans l'ordre de leur distance on va générer les blocs
        this.generateStoreBloc(storesOrdonnee);

        // On signale que tous les magasin ont été chargé
        storeLocator.addClass('loaded');
    },
    // Pour générer les bloc des magasins
    generateStoreBloc: function(stores) {

        var self = this;
        var storeLocator = $('.store_locator', Eresa.box);

        // On vide le bloque
        storeLocator.html('');
        // Les magasins avec au moin 1 stock
        var nbStoreAvailable = 0;
        // Les magasins assez proche
        var nbStoreAvailableNear = 0;
        $.each(stores, function(index, store) {
            // On regarde si il y a un horaire de renseigner
            if (store.schedule !== '') {
                // On va mettre la class actif
                store.showSchedule = 'actif';
            } else {
                store.showSchedule = '';
            }
            store.showQuantity = '';
            store.S_article = '';
            if (store.quantity < 5) {
                if (store.quantity > 1) {
                    // Juste pour mettre un s à articles
                    store.S_article = 's';
                }
            }
            // Si il n'y a pas assez de stock alors on n'affiche pas le magasin
            nbStoreAvailable ++;
            if (store.distance <= self.nbKilometerMax) {
                var html = Mustache.render(
                    self.storeHtml,
                    store
                );
                $(html).appendTo(storeLocator);
                nbStoreAvailableNear ++;
            }
        });

        var report = $('<div>', {class: 'js_store_report'});
        if (nbStoreAvailable === 0 || nbStoreAvailableNear === 0) {
            if (nbStoreAvailable === 0) {
                report.html(Translator.translate('store_not_available_quantity'));
            } else if (nbStoreAvailableNear === 0) {
                report.html(Translator.translate('store_not_available_near'));
            }
            $(report).appendTo(storeLocator);
        }

        // L'event pour afficher les horaires
        $('.js_have_horaire_store.actif', storeLocator).on('click', function(event) {
            event.preventDefault();
            var sheduleStore = $(this).next('.schedule_store');
            // Pour afficher les horaires du magasins
            if (!sheduleStore.hasClass('actif')) {
                sheduleStore.addClass('actif');
            } else {
                sheduleStore.removeClass('actif');
            }
        });
    },
    // Dans le cas où on change de couleur
    onChangeColor: function() {
        var color = $('input[name=itm_color]:checked', Eresa.box);
        var size = $('input[name=itm_size]:checked', Eresa.box);
        var productId = color.data('productid');
        var data = {
            'produit_id': productId,
            'couleur_id': color.val(),
            'taille_id': size.val(),
        };
        if (color.data('regroupement') === 1) {
            // Chargement du nouveau produit en cas de regroupement
            this.loadStepEresa(data, 1);
        } else {
            // Changement de l'image
            $('#js_product_bookinstore_img').attr('src', color.data('pic'))
        }
    },
    // Permet de récupérer toutes les informations du produits
    /**
     *
     * @param data
     * @param statut => le statut de chargement (0, 1) les chiffres sont les numéros d'étape (0 => init)
     */
    loadStepEresa: function(data, statut) {
        // Chargement
        $('.steps', Eresa.box).addClass('loading');
        $.ajax({
            url: path_relative_root + 'ajax_bookinstore_produit.php',
            type: 'POST',
            data: data,
            success: function(response){
                try {
                    response = $.parseJSON(response);
                } catch(e){
                    console.error('parseJSON');
                    return;
                }

                if (response.success === 'ok'){

                    var datas = response.datas;
                    var html = $(datas.html);

                    if (statut === 0) {
                        var formEresa = $('#form_eresa');
                        Eresa.content.html(html);
                        // On va déplacer le formulaire de vue JS au bon endroit
                        $('#js_form_infos_bookinstore_vue').append(formEresa);

                        // Ouverture de la ligthbox
                        openMultiShad(Eresa.boxName);
                    } else if (statut === 1) {
                        var step1 = $('#step1', html).html();
                        var step4 = $('#step4', html).html();
                        $('#step1', Eresa.content).html(step1);
                        $('#step4', Eresa.content).html(step4);
                    }
                    // Chargement
                    $('.steps', Eresa.box).removeClass('loading');

                } else {
                    alertV2(response.error.msg);
                }
            },
            complete: function(){
            }
        });
    },
    // Pour vérifier les information du produit
    checkProduct: function() {
        if (typeof $('input[name=itm_color]:checked', Eresa.box).val() === 'undefined' && typeof $('input[name=itm_size]:checked', Eresa.box).val() === 'undefined') {
            alertV2(Translator.translate('choose_a_size_and_a_color'));
            return false;
        } else if (typeof $('input[name=itm_color]:checked', Eresa.box).val() === 'undefined') {
            alertV2(Translator.translate('js_error_couleur'));
            return false;
        } else if (typeof $('input[name=itm_size]:checked', Eresa.box).val() === 'undefined') {
            alertV2(Translator.translate('js_error_size'));
            return false;
        }
        var color = $('input[name=itm_color]:checked', Eresa.box);
        var size = $('input[name=itm_size]:checked', Eresa.box);
        $('#TailleIdBookInStore').val(size.val());
        $('#CouleurIdBookInStore').val(color.val());
        $('#ProduitIdBookInStore').val(color.data('productid'));

        Eresa.product.product_id = color.data('productid');
        Eresa.product.color_id = color.val();
        Eresa.product.size_id = size.val();

        // On va attribuer les valeurs pour le récapitulatif (taille et couleur)
        $('#js_color').html(color.data('name'));
        $('#js_size').html(size.data('name'));
        return true;
    },
    // Pour vérifier les informations du magasin
    checkStore: function(btn) {
        var self = this;
        $('#StoreIdBookInStore').val($(btn).data('magasinid'));
        // Enregistrement des informations du magasin (pour l'étape récapitulatif)
        // On va rechercher le magasin selectionné dans la liste
        $.each(this.stores, function(index, store) {
            if (store.id === $(btn).data('magasinid')) {
                self.storeSelected = store;
            }
        });
        return true;
    },
    next: function() {
        // Verification que la couleur et la taille ont bien été choisie
        if (Eresa.step === 1) {
            if (!Eresa.checkProduct()) {
                return false;
            }
        } else if(Eresa.step === 2) { // Choix du magasin
            if (!Eresa.checkStore(this)) {
                return false;
            }
        } else if(Eresa.step === 3) { // Formulaire
            // La vérification du formulaire est faite dans le vuejs (w-pdv-form)
        }

        // On "desactive" l'ancienne étape
        $('#step' + Eresa.step).removeClass('actif');
        $('.popup_desc').hide();

        // ONGLET : On "desactive" l'ancienne étape
        $('.step_num[data-step='  + Eresa.step + ']').removeClass('actif');

        Eresa.step++;
        // ONGLET : On "active" la nouvelle étape étape
        $('.step_num[data-step='  + Eresa.step + ']').addClass('actif');
        // Au chargement de la 2eme étape on charge les magasin
        if (Eresa.step === 2) {
            Eresa.storeInit();
        } else if (Eresa.step === 4) { // validation du choix et envoi des informations
            var form = $('#form_eresa').serialize();
            $.ajax({
                url: path_relative_root + 'ajax_bookinstore_client.php',
                type: 'POST',
                data: form,
                dataType: 'json',
                success: function (response){
                    if (response.success) {
                        $('#step' + Eresa.step + ' .confirm').css('display', 'block');
                    } else {
                        $('#step' + Eresa.step + ' .confirm').css('display', 'none');
                        $('#step' + Eresa.step + ' .error').html(response.error_msg).css('display', 'block');
                    }

                    $(".step_content .confirm_info").appendTo(".popup_header");

                    // On va attribuer les valeurs pour le récapitulatif (taille et couleur)
                    $('#js_color').html(response.product.color.name);
                    $('#js_size').html(response.product.size.name);

                    // Attribution des information du magasin
                    var html = Mustache.render(
                        Eresa.storeHtml,
                        Eresa.storeSelected
                    );

                    $('#js_eresa_store_choice').html(html);

                    // L'event pour afficher les horaires
                    $('.js_have_horaire_store.actif', $('#js_eresa_store_choice')).on('click', function(event) {
                        event.preventDefault();
                        var sheduleStore = $(this).next('.schedule_store');
                        // Pour afficher les horaires du magasins
                        if (!sheduleStore.hasClass('actif')) {
                            sheduleStore.addClass('actif');
                        } else {
                            sheduleStore.removeClass('actif');
                        }
                    });

                    // On "active" la nouvelle étape
                    $('#step' + Eresa.step).addClass('actif');
                }
            });
        } else {
            // On "active" la nouvelle étape
            $('#step' + Eresa.step).addClass('actif');
        }
    },
    // Montre la lightbox des points de ventes
    show: function() {
        var produitId = $('#produit_id').val();

        var couleurId = $('#couleurProd_' + produitId).val();
        var tailleId = $('#tailleProd_' + produitId).val();
        var data = {
            'produit_id': produitId,
            'couleur_id': couleurId,
            'taille_id': tailleId,
        };
        // Chargement du produit dans la lightbox
        Eresa.loadStepEresa(data, 0);

        Eresa.step = 1;

    },
    // Cache la lightbox des points de ventes
    close: function() {

        closeMultiShad(Eresa.boxName);
        setTimeout(function() {Eresa.RAZ()}, 1000);
    },

    // Remet à 0 les step
    RAZ: function() {
        // On revient à l'étape 1
        Eresa.step = 1;
        // On désactive tout
        $('.step').removeClass('actif');
        $('.step_num').removeClass('actif');
        // On active l'étape 1
        $('#step' + Eresa.step).addClass('actif');
        // ONGLET : On "active" l'étape 1
        $('.step_num[data-step='  + Eresa.step + ']').addClass('actif');
    }
};